import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CdsIconConfig } from '@cds/ng-core/icon';
import { ActionIcons } from '@cds/ng-themes';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-cd-back-text',
  templateUrl: './cd-back-text.component.html',
  styleUrls: ['./cd-back-text.component.scss'],
  imports: [CdsIconModule],
})
export class CdBackTextComponent implements OnInit {
  @Input() title?: string;
  @Output() backCall = new EventEmitter<void>();
  backIconConfig: CdsIconConfig = {
    color: 'cta',
    size: 'sm',
  };
  backIcon = ActionIcons.left_outlined;

  constructor() {}

  ngOnInit(): void {}

  onBack() {
    this.backCall.emit();
  }
}
